import { ListItem, ListItemIcon } from "@material-ui/core";
import Radio from "@material-ui/core/Radio/Radio";
import React from "react";
import ListItemText from "@material-ui/core/ListItemText";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { alpha } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.primary.light,
    "&:first-child": {
      //borderTop: '1px solid ' + theme.palette.primary.light,
    },
    "&:last-child": {
      //borderTop: '1px solid ' + theme.palette.primary.light,
      borderBottom: "none",
    },
    "& .MuiListItemIcon-root": {
      minWidth: 0,
      marginRight: theme.spacing(1),
    },
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  selected: {
    backgroundColor: "red",
    "&.MuiListItem-root, &.MuiListItem-root:active, &.MuiListItem-root:hover":
      {
        backgroundColor: alpha(theme.palette.secondary.main, 0.2),
        //borderBottom: '1px solid ' + alpha(theme.palette.secondary.main, 0.20),
      },
  },
  primary: {
    fontWeight: 500,
    fontSize: theme.clientType == "desktop" ? "20px" : "15px",
  },
  secondary: {
    fontSize: theme.clientType == "desktop" ? "15px" : "12px",
    color: "#232323",
  },
}));

export default ({
  selected,
  onClick,
  primaryText,
  secondaryText,
  action,
  disabled,
  labelId,
}) => {
  const classes = useStyles();

  return (
    <ListItem
      button
      selected={selected}
      onClick={onClick}
      classes={{ root: classes.root, selected: classes.selected }}
      disabled={disabled}
    >
      <ListItemIcon>
        <Radio
          edge="start"
          checked={selected}
          inputProps={{ "aria-labelledby": labelId }}
          tabIndex={-1}
        />
      </ListItemIcon>
      <ListItemText
        id={labelId}
        classes={{ primary: classes.primary, secondary: classes.secondary }}
        primary={primaryText}
        secondary={secondaryText}
      />
      {action && action}
    </ListItem>
  );
};
